import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "ticket-add-tag",
  id: "ticket-add-tag"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "标签", -1)
const _hoisted_3 = { class: "labelSets" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "选中标签", -1)
const _hoisted_6 = { class: "labels-selected" }
const _hoisted_7 = {
  key: 0,
  class: "label"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("div", null, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketLabelSetList, (s) => {
            return (_openBlock(), _createBlock("div", {
              class: "labelSet",
              key: s.id
            }, [
              _createVNode(_component_el_card, {
                class: "box-card",
                shadow: "never"
              }, {
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("span", null, _toDisplayString(s.labelSetName), 1),
                    _createVNode(_component_el_button, {
                      class: "button",
                      type: "text",
                      onClick: ($event: any) => (s.showCheckList = !s.showCheckList)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(s.showCheckList ? '关闭' : '展开'), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  (s.showCheckList)
                    ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                        key: 0,
                        modelValue: s.checkList,
                        "onUpdate:modelValue": ($event: any) => (s.checkList = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(s.labels, (l) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              label: l.id,
                              key: l.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(l.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ])
      ]),
      _createVNode("div", null, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketLabelSetList, (s) => {
            return (_openBlock(), _createBlock(_Fragment, null, [
              (s.checkList.length > 0)
                ? (_openBlock(), _createBlock("div", {
                    key: s.id
                  }, [
                    _createVNode("div", null, _toDisplayString(s.labelSetName), 1),
                    _createVNode("div", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(s.labels, (l) => {
                        return (_openBlock(), _createBlock(_Fragment, {
                          key: l.id
                        }, [
                          (s.checkList.includes(l.id))
                            ? (_openBlock(), _createBlock("span", _hoisted_7, [
                                _createVNode("span", null, _toDisplayString(l.name), 1),
                                _createVNode("i", {
                                  class: "el-icon-close",
                                  onClick: ($event: any) => (s.checkList.splice(s.checkList.indexOf(l.id), 1))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(_ctx.selectedLabels))),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ])
  ]))
}